import _sfc_main from './english-menu.vue2.js';
/* empty css                 */
import _export_sfc from '../../../_virtual/_plugin-vue_export-helper.js';

const englishMenu = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-d508df08"]]);

export { englishMenu as default };
//# sourceMappingURL=english-menu.js.map
